document.addEventListener('DOMContentLoaded', () => {
    const selector = '.js-broker-list';
    if ((document.querySelector(selector) !== null)) {
        import('./borker-filter').then(({ filter }) => {
            filter();
        });
    }
});
